import classNames from 'classnames';
import React from 'react';
import { useI18n } from '@udemy/i18n';
import { Button } from '@udemy/react-core-components';
import styles from "./teach-on-udemy-banner.module.css";
export const TeachOnUdemyBanner = ({
  isAggregatorEnabled = false
}) => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('footer-section', styles['banner'], {
      'footer-section-med-background': isAggregatorEnabled,
      'footer-section-med-border': isAggregatorEnabled
    }),
    "data-testid": "teach-on-udemy-banner"
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "ud-heading-lg"
  }, gettext('Teach the world online')), /*#__PURE__*/React.createElement("div", {
    className: classNames('ud-text-md', styles['subtitle'])
  }, gettext('Create an online video course, reach students across the globe, and earn money'))), /*#__PURE__*/React.createElement("div", {
    className: styles['button-container']
  }, /*#__PURE__*/React.createElement(Button, {
    componentClass: "a",
    href: "/teaching/?ref=bai-sub-footer",
    udStyle: "white-outline"
  }, gettext('Teach on Udemy'))));
};
//# sourceMappingURL=teach-on-udemy-banner.react-component.js.map